import { Icon, Typography } from '@repo/ui';
import { ReactNode, useState } from 'react';
import styles from './ConditionFlagsSection.module.css';

export const ConditionFlagsSection = ({
  label,
  count,
  defaultExpanded = false,
  onExpand,
  children,
}: {
  label: string;
  count: number;
  defaultExpanded?: boolean;
  onExpand?: () => void;
  children: ReactNode;
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggle = () => {
    setExpanded(prev => {
      if (!prev) onExpand?.();
      return !prev;
    });
  };

  const title = count > 0 ? `${label} (${count})` : label;

  return (
    <div className={styles.section}>
      <div
        className={styles.header}
        role='button'
        tabIndex={0}
        aria-expanded={expanded}
        onClick={toggle}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <Typography variant='heading-s' className={styles.title}>
          {title}
        </Typography>
        <Icon name={expanded ? 'chevronUp' : 'chevronDown'} size='m' />
      </div>
      {expanded && <>{children}</>}
    </div>
  );
};
